<template>
  <section v-if="products.length > 0" class="section !py-[4rem]">
    <div class="container-lg">
      <div class="mb-12">
        <h2 class="section__title">{{ in18['page_recommended_product'] }}</h2>
        <div class="section__text">{{  in18['page_recommended_product_subtitle'] }}</div>
      </div>
      <div class="row  slider-no-dots" data-mobile-slider>
        <div v-for="product in products" class="col-md-3">
          <product-item :product="product"></product-item>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </section>
</template>

<script>
export default {
  name:  "RecommendedProducts",
  props: {
    product: Object,
    in18: {
      type: Object
    }
  },
  data() {
    return {
      products: [],
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get( `/api/product/recommended/${this.product.id}`).then((response) => {
        this.products = response.data.products;
      });
    },
  }
}
</script>
